import { ROUTES } from '@/shared/config/routes';

export const COMPETITOR_IDS = ['dikidi', 'easyweek', 'treatwell', 'goldie', 'bumpix'] as const;
export type CompetitorId = (typeof COMPETITOR_IDS)[number];

export type Competitor = {
  id: CompetitorId;
  /** Brand name as the competitor writes it; never translated. */
  name: string;
  path: string;
  /** Which KrasaHub price to compare against: hryvnia or euro. */
  market: 'ua' | 'eu';
  /** Share of a new client's bill a marketplace keeps; enables the savings calculator. */
  commissionRate?: number;
};

/**
 * Competitors with a comparison page, from the market research (§competitor
 * analysis and the BOFU URL matrix). Copy lives in the `comparison` namespace
 * and states only verifiable product facts (prices, limits, commission, the
 * product model) — no retold user complaints and nothing political. Unknown
 * facts render as a dash.
 */
export const COMPETITORS: Record<CompetitorId, Competitor> = {
  dikidi: { id: 'dikidi', name: 'DIKIDI', path: ROUTES.vs.dikidi, market: 'ua' },
  easyweek: { id: 'easyweek', name: 'EasyWeek', path: ROUTES.vs.easyweek, market: 'ua' },
  treatwell: {
    id: 'treatwell',
    name: 'Treatwell',
    path: ROUTES.vs.treatwell,
    market: 'eu',
    commissionRate: 0.35,
  },
  goldie: { id: 'goldie', name: 'Goldie', path: ROUTES.vs.goldie, market: 'eu' },
  bumpix: { id: 'bumpix', name: 'Bumpix', path: ROUTES.vs.bumpix, market: 'ua' },
};

/** Rows of the comparison table, in display order. */
export const MATRIX_FACTORS = [
  'price',
  'freeLimit',
  'commission',
  'telegram',
  'showcase',
  'clients',
] as const;
export type MatrixFactor = (typeof MATRIX_FACTORS)[number];

export const PAIN_KEYS = ['one', 'two', 'three'] as const;
export const STEP_KEYS = ['register', 'services', 'link'] as const;
export const FAQ_KEYS = ['migrate', 'free', 'commission', 'data', 'cancel'] as const;
